import styled from 'styled-components';

export const BlocContent = styled('div')`
    background-color: ${(p) => p.theme.white};
    border-radius: 18px;
    padding: 20px 0px;
`;